import { Link } from 'react-router';
import styles from './project-sharing.module.less';

export const ProjectSharingFooter = ({ backLink, forwardLink, backLinkText, forwardLinkText }) => {
    return (
        <div className={styles.prevNextContainer}>
            <Link className={styles.navigationLink} to={backLink}>
                ← {backLinkText}
            </Link>
            <Link className={styles.navigationLink} to={forwardLink}>
                {forwardLinkText} →
            </Link>
        </div>
    );
};
